import React, { useEffect, useRef, useState } from 'react'
import '../Style/Manage_Site_Section_Com.css'
import BlogsComponent from '../Components/Manage_Site_Blog_Com'
import ProductsComponent from '../Components/Manage_Site_Product_Com'
import AccountsComponent from '../Components/AccountsComponent'
import SearchIcon from '../Logos/search.svg'
import AddIcon from '../Logos/plus.svg'
import axios from 'axios'
import Manager from '../Components/ServerManagerCom'

function Manage_Site_Section_Com(Section = "Blogs") {
  const [ManagerStatus, SetManagerStatus] = useState(false)
  const [TypeOfManagement, SetTypeOfManagement] = useState()
  const [BlogsData, SetBlogsData] = useState()
  const [BlogName, SetBlogName] = useState()
  const [ProductsData, SetProductsData] = useState(null)
  const [ProductName, SetProductName] = useState("")
  const [OfferedProductsCount, SetOfferedProductsCount] = useState()
  const [ProductSection, SetProductSection] = useState("روشنایی")


  const [AccountsData, SetAccountsData] = useState()
  const [AccountName, SetAccountName] = useState()

  const SearchBlogInput = useRef()

  const ToggleManager = () => {
    SetManagerStatus(!ManagerStatus)
  }

  const Get_All_Blogs = () => {
    axios.post("http://127.0.0.1:3001/blogs")
      .then(data => {
        SetBlogsData(data.data)
      })
      .catch(err => { console.log(err) })
  }

  const Search_Blog = (e) => {
    axios.post("http://127.0.0.1:3001/select-blog", { BlogName })
      .then(data => {
        SetBlogsData(data.data)
      })
      .catch(err => { console.log(err) })
  }


  const Load_Products_From_Specific_Category = () => {
    axios.post("http://127.0.0.1:3001/products", { ProductSection })
      .then(data => {
        SetProductsData(data.data)
      })
      .catch(err => { console.log(err) })
  }

  const Search_Product_From_Specific_Category = () => {
    axios.post("http://127.0.0.1:3001/select-product", { ProductSection, ProductName })
      .then(data => {
        // console.log(data.data)
        SetProductsData(data.data)
      })
      .catch(err => { console.log(err) })
  }


  const Load_All_Account = () => {
    axios.post("http://127.0.0.1:3001/get-accounts")
      .then(data => {
        SetAccountsData(data.data)
      })
      .catch(err => { console.log(err) })
  }


  useEffect(() => {
    Get_All_Blogs()
    Load_Products_From_Specific_Category()
    Load_All_Account()
  }, [])



  return (
    <>
      {ManagerStatus ? <Manager Section={Section} Type={TypeOfManagement} OnFomClose={() => { SetManagerStatus(false) }} /> : null}
      {Section.Section === "Blogs" ? <div className='manage-site-section-container'>
        <div className='title'>بلاگ ها</div>
        <div className='number-of-blogs'>تعداد کل بلاگ ها: {BlogsData ? BlogsData.length : null}</div>
        <div className='search-blog-input'>
          <img src={SearchIcon} />
          <input type='text' name='search-blogs-input' placeholder='جست و جو بلاگ...' className='search-input' ref={SearchBlogInput} onChange={(e) => {
            SetBlogName(e.target.value)
            if (!e.target.value.length > 0) {
              Get_All_Blogs()
            } else {
              Search_Blog()
            }
          }} />
        </div>
        <div className='add-blog'>
          <img src={AddIcon} />
          <div className='text' onClick={() => {
            ToggleManager()
            SetTypeOfManagement("Add")
          }}>افزودن بلاگ</div>
        </div>
        <div className='blogs-list'>
          {BlogsData ? BlogsData.map((Blogs, key) => {
            return <BlogsComponent key={key} Blog_Data={Blogs} />
          }) : null}
        </div>
      </div> : null}
      {Section.Section === "Products" ? <div className='manage-site-section-container' onLoad={() => {}}>
        <div className='title'>محصولات</div>
        <div className='number-of-products'>تعداد کل محصول ها: {ProductsData ? ProductsData.length : "0"}</div>
        <select className='products-dropdown-selector' onChange={(e) => {
          SetProductSection(e.target.value)
          Load_Products_From_Specific_Category()
        }}>
          <option value={"روشنایی"} selected>روشنایی</option>
          <option value={"صوتی"}>صوتی</option>
          <option value={"کنترل"}>کنترل و ریموت</option>
        </select>
        <div className='search-product-input'>
          <img src={SearchIcon} />
          <input type='text' name='search-product-input' placeholder='جست و جو محصول...' className='search-input' onChange={(e) => {
            SetProductName(e.target.value)
            if (!e.target.value.length > 0) {
              Load_Products_From_Specific_Category()
            } else {
              Search_Product_From_Specific_Category()
            }
          }} />
        </div>
        <div className='add-product'>
          <img src={AddIcon} />
          <div className='text' onClick={() => {
            ToggleManager()
            SetTypeOfManagement("Add")
          }}>افزودن محصول</div>
        </div>
        <div className='manager-products-list'>
          {ProductsData ? ProductsData.map((Products, key) => {
            return <ProductsComponent key={key} Product_Data={Products} />
          }) : null}
        </div>
      </div> : null}

      {Section.Section === "Accounts" ? <div className='manage-site-section-container' onLoad={() => {}}>
        <div className='title'>حساب ها</div>
        <div className='number-of-accounts'>تعداد کل حساب ها: {AccountsData ? AccountsData.length : "0"}</div>
        <div className='search-accounts-input'>
          <img src={SearchIcon} />
          <input type='text' name='search-product-input' placeholder='جست و جو حساب...' className='search-input' onChange={(e) => {
            SetAccountName(e.target.value)
            if (!e.target.value.length > 0) {
            } else {
            }
          }} />
        </div>
        <div className='manager-accounts-list'>
          {AccountsData ? AccountsData.map((Account, key) => {
            return <AccountsComponent key={key} Account_Data={Account} />
          }) : null}
        </div>
      </div> : null}
    </>
  )
}

export default Manage_Site_Section_Com